import React, { useEffect, useState, useContext } from "react";
import { Amplify } from "aws-amplify";
import { fetchUserAttributes } from "aws-amplify/auth";
import { Authenticator } from "@aws-amplify/ui-react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import awsExports from "./aws-exports";
import Layout from "./components/Layout";
import Usage from "./pages/Usage";
import EvidenceTools from "./pages/EvidenceTools";
import Settings from "./pages/Settings";
import Profile from "./pages/Profile";
import Plan from "./pages/Plan";
import NotFound from "./pages/NotFound";
import { AppProvider, AppContext } from "./store/AppContext";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import "@aws-amplify/ui-react/styles.css";
import "./App.css";
import "./auth-styles.css";

Amplify.configure(awsExports);

// Define custom theme (Vuetify-like colors)
const theme = createTheme({
  palette: {
    primary: {
      main: "#002966", // Vuetify-style blue
    },
    secondary: {
      main: "#FF4081", // Accent color
    },
  },
  typography: {
    button: {
      textTransform: "none", // Removes uppercase styling from buttons
    },
  },
});

function AppContent() {
  const [userDetails, setUserDetails] = useState(null);
  const [authUser, setAuthUser] = useState(null);
  const { dispatch } = useContext(AppContext);

  useEffect(() => {
    async function fetchUserData() {
      if (!authUser) return;
      try {
        const attributes = await fetchUserAttributes();
        setUserDetails(attributes);
        dispatch({ type: "SET_USER_DETAILS", payload: attributes });
      } catch (error) {
        console.error("Error fetching user attributes:", error);
      }
    }
    fetchUserData();
  }, [authUser, dispatch]);

  return (
    <ThemeProvider theme={theme}>
      <Authenticator class="auth-component" loginMechanisms={["email"]}>
        {({ signOut, user }) => {
          if (user && authUser !== user) {
            setAuthUser(user);
          }

          return (
            <Router>
              <Layout signOut={signOut} user={userDetails || user}>
                <Routes>
                  <Route path="/" element={<Usage />} />
                  <Route path="/evidence-tools" element={<EvidenceTools />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/plan" element={<Plan />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Layout>
            </Router>
          );
        }}
      </Authenticator>
    </ThemeProvider>
  );
}

export default function App() {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
}
